/* ---------------------------------------------------------------------------------------------
 * Copyright (c) Infiniscene, Inc. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * -------------------------------------------------------------------------------------------- */
import { RoomsManager } from './room-context'

/**
 * our singleton
 */
export const webrtcManager = new RoomsManager()
